import {toast} from 'react-toastify';
export const AppNotify = (msg, type) => toast(msg, {type});